// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2Fosc","label":"CategoryService_label__4COMi","location":"CategoryService_location__1GMRU"};